import {
    COMPANY_USERS_LOADING,
    COMPANY_USERS_SUCCESS,
    COMPANY_USERS_FAIL,
    COMPANY_USER_GET_SUCCESS,
    COMPANY_USER_CREATE_SUCCESS,
    COMPANY_USER_UPDATE_SUCCESS,
    COMPANY_USER_DELETE_SUCCESS,
    COMPANY_USERS_CLEAR_ERRORS,
    COMPANY_USERS_CLEAR_CURRENT,
    COMPANY_USERS_SET_PAGINATION,
    MY_COMPANIES_SUCCESS,
    COMPANY_USER_ASSIGNMENTS_LOADING,
    COMPANY_USER_ASSIGNMENTS_SUCCESS,
    COMPANY_USER_ROLE_ASSIGN_SUCCESS,
    COMPANY_USER_ROLE_UPDATE_SUCCESS,
    COMPANY_USER_ROLE_REMOVE_SUCCESS
} from '../actions/CompanyUsersActions';

const initialState = {
    companyUsers: [],
    currentUser: null,
    myCompanies: [],
    userAssignments: [], // For role assignments
    loading: false,
    assignmentsLoading: false, // Separate loading for assignments
    error: null,
    validationErrors: null,
    pagination: {
        total: 0,
        page: 1,
        limit: 10,
        totalPages: 0
    },
    temporaryPassword: null
};

const CompanyUsersReducer = (state = initialState, action) => {
    switch (action.type) {
        case COMPANY_USERS_LOADING:
            return {
                ...state,
                loading: true,
                error: null,
                validationErrors: null
            };

        case COMPANY_USERS_SUCCESS:
            return {
                ...state,
                loading: false,
                companyUsers: action.payload,
                error: null,
                validationErrors: null
            };

        case COMPANY_USER_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                currentUser: action.payload,
                error: null,
                validationErrors: null
            };

        case COMPANY_USER_CREATE_SUCCESS:
            // Handle both assignment object and user object
            const newUser = action.payload.assignment || action.payload.user;
            return {
                ...state,
                loading: false,
                companyUsers: newUser ? [newUser, ...state.companyUsers] : state.companyUsers,
                temporaryPassword: action.payload.user?.temporaryPassword || null,
                error: null,
                validationErrors: null
            };

        case COMPANY_USER_UPDATE_SUCCESS:
            return {
                ...state,
                loading: false,
                companyUsers: state.companyUsers.map(user =>
                    user.assignmentId === action.payload.id ? action.payload : user
                ),
                currentUser: action.payload,
                error: null,
                validationErrors: null
            };

        case COMPANY_USER_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                companyUsers: state.companyUsers.filter(
                    user => user.profileId !== action.payload
                ),
                error: null,
                validationErrors: null
            };

        case MY_COMPANIES_SUCCESS:
            return {
                ...state,
                loading: false,
                myCompanies: action.payload,
                error: null,
                validationErrors: null
            };

        case COMPANY_USERS_SET_PAGINATION:
            return {
                ...state,
                pagination: action.payload
            };

        case COMPANY_USERS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                validationErrors: action.validationErrors || null
            };

        case COMPANY_USERS_CLEAR_ERRORS:
            return {
                ...state,
                error: null,
                validationErrors: null,
                temporaryPassword: null
            };

        case COMPANY_USERS_CLEAR_CURRENT:
            return {
                ...state,
                currentUser: null,
                error: null,
                validationErrors: null,
                temporaryPassword: null
            };

        // Role Assignment Cases
        case COMPANY_USER_ASSIGNMENTS_LOADING:
            return {
                ...state,
                assignmentsLoading: true,
                error: null,
                validationErrors: null
            };

        case COMPANY_USER_ASSIGNMENTS_SUCCESS:
            return {
                ...state,
                assignmentsLoading: false,
                userAssignments: action.payload,
                error: null,
                validationErrors: null
            };

        case COMPANY_USER_ROLE_ASSIGN_SUCCESS:
            return {
                ...state,
                assignmentsLoading: false,
                userAssignments: [action.payload, ...state.userAssignments],
                // Also update companyUsers list if the user exists there
                companyUsers: state.companyUsers.map(user =>
                    user.userId === action.payload.userId
                        ? { ...user, ...action.payload }
                        : user
                ),
                error: null,
                validationErrors: null
            };

        case COMPANY_USER_ROLE_UPDATE_SUCCESS:
            return {
                ...state,
                assignmentsLoading: false,
                userAssignments: state.userAssignments.map(assignment =>
                    assignment.id === action.payload.id ? action.payload : assignment
                ),
                // Also update companyUsers list if needed
                companyUsers: state.companyUsers.map(user =>
                    user.assignmentId === action.payload.id
                        ? { ...user, ...action.payload }
                        : user
                ),
                error: null,
                validationErrors: null
            };

        case COMPANY_USER_ROLE_REMOVE_SUCCESS:
            return {
                ...state,
                assignmentsLoading: false,
                userAssignments: state.userAssignments.filter(
                    assignment => assignment.id !== action.payload
                ),
                error: null,
                validationErrors: null
            };

        default:
            return state;
    }
};

export default CompanyUsersReducer;
